import { formatDate } from "helpers/common_helpers";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { cancelSubscription, myCurrentSubscription } from "store/actions/subscriptionSlice";
import classNames from "classnames";
import { CurrencySymbol, formatPlanType, getMinMaxDate } from "components/common/Utils";
import { useNavigate } from "react-router-dom";
import { showAlert } from "store/reducers/alertReducer";
import logo from "../../../assets/images/footerLogo.svg";
import planBenefitImage from "../../../assets/images/icons/checked.svg";
import { getCompanyInfo } from "store/actions/authSlice";
import { Modal } from "react-bootstrap";
import tick from "assets/images/icons/tick.svg";
import circle from "assets/images/icons/cancel.svg";
import { ChevronLeft } from "lucide-react";
import PlanUpgrade from "./PlanUpgrade/PlanUpgrade";

function MyPlanInfo() {
  const { t,

    i18n } = useTranslation();
  const {
    isLoading,
    allPlans,
    mySubscriptionDetails,
  } = useSelector(
    (state) => state.Subscriptions
  );
  const [planType, setPlanType] = useState(null);
  const [selectedPlan, setselectedPlan] = useState(null);

  const [subTotal, setSubTotal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [discountAmount, setdiscountAmount] = useState(0);
  const [isCancelled, setIsCancelled] = useState(false);
  const [show2, setShow2] = useState(false);

  const handleHideModal2 = () => setShow2(false);


  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleUpdatePlan = () => {
    // return;
    // const { isTrial, planId } = mySubscriptionDetails || {};
    const { name } = selectedPlan;

    // IF HAVE FREE_TRIAL THEN REDIRECT TO PLAN PAGE:
    navigate(`/subscription?selectedPlan=${name}`);
    return;
    // if (isTrial) {
    // } else {
    //   handleShow(true);
    // }
  };
  const [show, setShow] = useState(false);
  const [continueBtn, setContinueBtn] = useState(true);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);


  const handleCancelSubscription = () => {
    dispatch(cancelSubscription())
      .then((action) => {
        const { statusCode, success, message } = action?.payload;
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }));
          dispatch(getCompanyInfo());
          dispatch(myCurrentSubscription());
          setIsCancelled(true);
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch((err) => { });
  };
  useEffect(() => {
    const planOrder = ["Starter", "Professional", "Enterprise"];
    const currentPlan = mySubscriptionDetails?.planId?.name;
    const currentPlanIndex = planOrder.indexOf(currentPlan);

    // Filter plans: exclude current plan, lower-tier plans, and custom plans
    const filteredPlans = allPlans.filter((plan) => {
      const planIndex = planOrder.indexOf(plan.name);

      // Include non-custom plans that are higher in the order than the current plan
      return (!currentPlan || currentPlanIndex === -1 || planIndex > currentPlanIndex);
    });

    // Find the Enterprise plan if it exists in filtered plans, otherwise take first non-custom plan
    const enterprisePlan = filteredPlans.find(plan => plan.name === "Enterprise");
    const selectedPlan = filteredPlans[0] || enterprisePlan;

    // Set the selected plan and plan type
    if (selectedPlan) {
      setselectedPlan(selectedPlan);
      setPlanType(selectedPlan.name);
    } else {
      // Fallback: If no valid plan is found, clear selectedPlan and planType
      setselectedPlan(null);
      setPlanType("");
    }
  }, [allPlans, mySubscriptionDetails]);

  useEffect(() => {
    if (selectedPlan && !selectedPlan.isCustom) {
      setSubTotal(selectedPlan.discountedPrice);
      setdiscountAmount(selectedPlan.price - selectedPlan.discountedPrice);
      setTotalAmount(selectedPlan.discountedPrice);
      setContinueBtn(false);
    } else {
      setContinueBtn(true);
    }
  }, [selectedPlan]);
  useEffect(() => {
    const planBySelection = allPlans.find(
      (plan, index) => plan.name === planType
    );
    setselectedPlan(planBySelection)

  }, [planType]);


  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="common_card_2 mt-0">
          <div className="g_between gap-3 align-items-start flex-wrap">
            <div className="plan_div align-items-start">
              <div className="box"></div>
              <div>
                <h2 className="fs_12 text_dark_gray">{t("Plan")}</h2>
                <h2 className="fs_20 text_black text-capitalize">
                  {
                    mySubscriptionDetails.cancelledInfo?.isCancelled ?
                      t("No Active Plan") :
                      mySubscriptionDetails.isTrial ? "Free trial" : mySubscriptionDetails.billingCycle
                  }
                  {mySubscriptionDetails.cancelledInfo?.isCancelled && (
                    <h6 className="cancelled_text fs_14 text_danger">
                      Cancelled
                      {mySubscriptionDetails?.status !== 3 &&
                        `- active until ${formatDate(
                          mySubscriptionDetails?.billingCycleEnd
                        )}`}
                    </h6>
                  )}
                </h2>
              </div>
            </div>
            <div className="cancel_subscription_plan">
              {
                !mySubscriptionDetails.cancelledInfo?.isCancelled &&
                <button
                  onClick={() => setShow2(true)}
                  disabled={isLoading}
                  className="cancel_btn_2 d-block ms-auto">
                  {t("Cancel Subscription")}
                </button>
              }
            </div>
          </div>
          <div className="plan_details">
            <div className="single_details">
              <h2 className="fs_12 text_dark_gray">{t("Due On")}</h2>
              <h2 className="fs_14 text_black_3">
                {formatDate(mySubscriptionDetails?.trialEndDate)}
              </h2>
            </div>
            <div className="single_details">
              <h2 className="fs_12 text_dark_gray">{t("Locations")}</h2>
              <h2 className="fs_14 text_black_3">
                {mySubscriptionDetails?.features?.locations}
              </h2>
            </div>
            <div className="single_details">
              <h2 className="fs_12 text_dark_gray">{t("Members")}</h2>
              <h2 className="fs_14 text_black_3">
                {console.log("mySubscriptionDetails?.features?.members" , mySubscriptionDetails?.features?.members)}
                {mySubscriptionDetails?.features?.members}
              </h2>
            </div>
            <div className="single_details">
              <h2 className="fs_12 text_dark_gray">{t("Charged")}</h2>
              <h2 className="fs_14 text_black_3">
                {mySubscriptionDetails?.planId?.name}
              </h2>
            </div>
          </div>
        </div>
        <div className="common_card_2 mt-0">
          <h2 className="fs_20 text_black_2">{t("Update Your Plan")}</h2>
          <div className="row">
            {!isLoading && allPlans?.length > 0 ? (
              allPlans
                .filter((plan) => {
                  const currentPlan = mySubscriptionDetails?.planId?.name;
                  const planOrder = ["Starter", "Professional", "Enterprise"];
                  const currentPlanIndex = planOrder.indexOf(currentPlan);
                  const planIndex = planOrder.indexOf(plan.name);

                  // If no current plan, show all plans
                  if (!currentPlan || currentPlanIndex === -1) {
                    return true;
                  }

                  // Exclude the current plan and any plan "lower" in the order
                  return planIndex > currentPlanIndex;
                })
                .map((plan) => (
                  <div className="col-lg-4 mb-4" key={plan.id}>
                    <div
                      className={classNames("plan_picker_card_container", {
                        popular: plan.isPopular,
                        active: plan.name === planType,
                      })}
                    >
                      <div className="plan_details_top text-center d-flex">
                        <h2 className="plan_type">
                          {i18n.language === "ar" ? plan?.nameAr : plan?.name}
                        </h2>
                        {
                          plan?.highlightDescription &&
                        <h2 className="plan_highlight">
                          {i18n.language === "ar" ? plan?.highlightDescriptionAr : plan?.highlightDescription}
                        </h2>

                        }
                        <p className="plan_description">
                          {i18n.language === "ar"
                            ? plan.descriptionAr || plan.description
                            : plan.description}
                        </p>
                        <div className="plan_benefits_points">
                          <ul>
                            {plan.features.map((feature) => (
                              <li key={feature._id}>
                                <img
                                  src={planBenefitImage}
                                  width={18}
                                  height={18}
                                  alt="Work Space Logo"
                                />
                                <span>
                                  {i18n.language === "ar" ? feature.titleAr : feature.title}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <h2 className="plan_pricing">
                          {plan.isCustom ? (
                            <div>
                              <span>{t("Customisable Plan")}</span>
                            </div>
                          ) : (
                            <div>
                              <CurrencySymbol width="16" height="16" />
                              <span>{plan.price}</span>
                              <span className="plan_period">
                                /{formatPlanType(plan.billingCycle)}
                              </span>
                            </div>
                          )}
                        </h2>
                      </div>
                      <div className="plan_details_bottom">
                        <button
                          className="plan_picker_button"
                          onClick={() => {
                            setPlanType(plan.name);
                            setselectedPlan(plan);
                          }}
                        >
                          {plan.isCustom ? t("Contact Us") : t("Select")}
                        </button>
                      </div>
                    </div>
                  </div>
                ))
            ) : (
              !isLoading && <p>{t("No plans available")}</p>
            )}
          </div>
          <div className="row">
            <div className="col-lg-12">
              {planType !== "FREE_TRIAL" && planType !== "Enterprise" && (
                <div className="sub_total_row">
                  <div className="g_between align-items-start mt-2">
                    <h2 className="fs_14 text_black_2">{t("subtotal")}</h2>
                    <div>
                      <h2 className="fs_16 text_black_2 ltr">
                        <CurrencySymbol width="12" height="14" />
                        {subTotal.toFixed(2)}
                      </h2>
                    </div>
                  </div>
                  <div className="g_between align-items-start mt-2">
                    <h2 className="fs_14 text_black_2">{t("Discount")}</h2>
                    <div>
                      <h2 className="fs_16 text_success ltr">
                        <CurrencySymbol width="12" height="14" />
                        {/* {discountAmount ? "-" : null}
                                                            {discountAmount.toFixed(2)} */}
                        {discountAmount.toFixed(2)}
                      </h2>
                    </div>
                  </div>
                  <div className="g_between align-items-start mt-2">
                    <h2 className="fs_20 text_black_2">{t("Total")}</h2>
                    <div>
                      <h2 className="fs_20 text_black_2 text-end">
                        <CurrencySymbol
                          width="15"
                          height="17"
                        />
                        <span className="text_primary_2">{totalAmount.toFixed(2)}</span>
                      </h2>
                      <button
                        className="main_btn d-block ms-auto continue_btn"
                        onClick={handleUpdatePlan}
                        disabled={isLoading || continueBtn}
                      >
                        {t("Continue")}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        fullscreen
        className="plan_upgrade_modal"
      >
        <div className="inner_section">
          <div className="left_section">
            <img src={logo} alt="ease" width={123} height={40} />
            <div
              className={`d-flex gap-1 align-items-start cursor-pointer my_planinfo_modal ${i18n.language}`}
            >
              <ChevronLeft onClick={handleClose} />
              <h2>{t("Manage Workspace Plan and billing")}</h2>
            </div>
          </div>
          <div className="right_section">
            <PlanUpgrade
              planType={planType}
              selectedPlan={selectedPlan}
              setPlanType={setPlanType}
              setselectedPlan={setselectedPlan}
              handleClose={handleClose}

            />
          </div>
        </div>
      </Modal>
      <Modal
        show={show2}
        onHide={handleHideModal2}
        centered
        className="common_modal w_408 cancel_sub_modal"
      >
        <img
          src={isCancelled ? tick : circle}
          alt="circle"
          width={50}
          height={50}
        />
        <h2 className="fs_20 mt_20">
          {isCancelled
            ? "Subscription cancelled successfully!"
            : "Cancel Subscription?"}
        </h2>
        <p className="fs_14 text_dark_gray_2 mt_15">
          {isCancelled
            ? `Your subscription has been successfully cancelled.You will continue to have access until the end of your current billing period on ${formatDate(
              mySubscriptionDetails?.billingCycleEnd
            )}`
            : `Your current plan will remain active until
          ${formatDate(mySubscriptionDetails?.billingCycleEnd)} Are you sure you
          want to cancel?`}
        </p>
        <div className="mt_30"></div>
        {!isCancelled && (
          <button className="main_btn " onClick={handleCancelSubscription}>
            Confirm Cancellation
          </button>
        )}
        <button className="cancel_btn mt_10" onClick={handleHideModal2}>
          Cancel
        </button>
      </Modal>
    </div>
  );
}

export default MyPlanInfo;
